import { I4BCellType } from '../configurations';
import { I4bCellConcept } from '../enums';
import { HeaderType } from '../models';
import { I4BButtonColumn } from './i4b-button.column';

export class DaliaDeviceTemplatesButtonColumn extends I4BButtonColumn {
  constructor() {
    super(
      {
        type: HeaderType.CALL_TO_ACTION,
        displayName: 'BUTTON',
        icon: ''
      },
      {
        concept: I4bCellConcept.FIRMWARES,
        isConfigurable: false,
        isDefault: true,
        isLink: false,
        position: '',
        sortProperty: '',
        width: 10,
        id: 'button',
        cell: {
          type: I4BCellType.CALL_TO_ACTION,
          bulkActions: [],
          singleActions: [
            {
              order: 0,
              key: 'editTemplate',
              label: 'DEVICE_TEMPLATES.EDIT_TEMPLATE',
              enableConditions: [
                [
                  { key: 'isEditable', value: true },
                  { key: 'canUpdateDevice', value: true }
                ]
              ],
              disableConditions: [],
              visibleConditions: []
            },
            {
              order: 1,
              key: 'duplicateTemplate',
              label: 'DEVICE_TEMPLATES.DUPLICATE_TEMPLATE',
              enableConditions: [[{ key: 'canCreateDevice', value: true }]],
              disableConditions: [],
              visibleConditions: []
            },
            {
              order: 2,
              key: 'deleteTemplate',
              label: 'DEVICE_TEMPLATES.DELETE_TEMPLATE',
              enableConditions: [
                [
                  { key: 'isEditable', value: true },
                  { key: 'canDeleteDevice', value: true }
                ]
              ],
              disableConditions: [],
              visibleConditions: []
            }
          ],
          disableConditions: [],
          visibleConditions: [[{ key: 'canReadDevice', value: true }]],
          enableConditions: []
        }
      },
      { order: 1000 }
    );
  }
}
